var React = require('react');
var ReactNative = require('react-native');

var Animated = require('./wrappers/Animated')

var Globals = require('./Globals');
var Tutorial = require('./Tutorial');
var ReUpButton = require('./ReUpButton');
var ReUpText = require('./ReUpText');
var { BlurView, VibrancyView } = require('./wrappers/react-native-blur-wrapper');
var PlatformConstants = require('./constants/PlatformConstants')

var AnalyticsManager = require('./AnalyticsManager');

var {
  View,
  StyleSheet,
  Image,
  Keyboard,
  ScrollView,
  findNodeHandle
} = ReactNative;

var InterstitialContainer = require("create-react-class")(
{
  getInitialState: function()
  {
    var thisThing = this;

    var state = {
      layout:{width:100, height:100},
      headerOpacity:new Animated.Value(0),
      title:"",
      keyboardOffset:new Animated.Value(0)
    };

    var createUserFeatureData = this.props.appManager.getFeatureForName('CreateUser');
    if( typeof createUserFeatureData !== 'undefined' )
    {
      state.createUserFeatureData = createUserFeatureData;
      state.createUserComponent = this.props.featureBuilder.featureForData(createUserFeatureData, {width:0, height:0}, this.props.appManager,
        {
          useInterstitialFlow: true,
          createUserDidFinish: (completion, shouldSkipRestOfTutorial)=>
          {
            if( typeof shouldSkipRestOfTutorial !== 'undefined' && shouldSkipRestOfTutorial )
            {
              thisThing.props.interstitialDidFinish();
            }
            else
            {
              thisThing.checkUserChanged();
              thisThing.refs.tutorial.goNext(completion);
            }
          },
          showNetworkErrorAlert: ()=>
          {
            thisThing.networkErrorOccurred();
          }
        });
    }

    var paymentTypePrereq = this.props.appManager.getPrerequisiteFeatureForName("PaymentTypes");
    var addCreditPrereq = this.props.appManager.getPrerequisiteFeatureForName("AddCredit");
    var phoneNumberVerifyFeatureData = this.props.appManager.getFeatureForName('PhoneNumberVerify');
    if( typeof phoneNumberVerifyFeatureData !== 'undefined'
      && ( (addCreditPrereq != null && addCreditPrereq.data.name == "PhoneNumberVerify") || (paymentTypePrereq != null && paymentTypePrereq.data.name == "PhoneNumberVerify") ))
    {
      state.phoneNumberVerifyFeatureData = phoneNumberVerifyFeatureData;
      state.phoneNumberVerifyComponent = this.props.featureBuilder.featureForData(phoneNumberVerifyFeatureData, {width:0, height:0}, this.props.appManager,
        {
          useInterstitialFlow: true,
          setPhoneDidFinish: (completion)=>
          {
            thisThing.forceUpdate();
            thisThing.refs.tutorial.goNext(completion);
          },
          showNetworkErrorAlert: ()=>
          {
            thisThing.networkErrorOccurred();
          }
        });
    }

    var addCreditFeatureData = this.props.appManager.getFeatureForName('AddCredit');
    var paymentTypesFeatureData = this.props.appManager.getFeatureForName('PaymentTypes');
    if( typeof paymentTypesFeatureData !== 'undefined' && typeof addCreditFeatureData !== 'undefined' )
    {
      state.paymentTypesFeatureData = paymentTypesFeatureData;
      state.paymentTypesComponent = this.props.featureBuilder.featureForData(paymentTypesFeatureData, {width:0, height:0}, this.props.appManager,
        {
          useInterstitialFlow: true,
          paymentTypesDidFinish: (completion)=>
          {
            thisThing.forceUpdate();
            thisThing.refs.tutorial.goNext(completion);
          },
          showNetworkErrorAlert: ()=>
          {
            thisThing.networkErrorOccurred();
          },
          interstitialDidFinish: thisThing.props.interstitialDidFinish
        });

      state.addCreditFeatureData = addCreditFeatureData;
      state.addCreditComponent = this.props.featureBuilder.featureForData(addCreditFeatureData, {width:0, height:0}, this.props.appManager,
        {
          useInterstitialFlow: true,
          addCreditDidFinish: (completion) =>
          {
            thisThing.refs.tutorial.goNext(completion);
          },
          showNetworkErrorAlert: ()=>
          {
            thisThing.networkErrorOccurred();
          }
        });
    }

    return state;
  },

  _keyboardWillShowSubscription: null,
  _keyboardWillHideSubscription: null,
  componentDidMount : function()
  {
    if( Keyboard )
    {
      this._keyboardWillShowSubscription = Keyboard.addListener('keyboardWillShow', (e) => this._keyboardWillShow(e));
      this._keyboardWillHideSubscription = Keyboard.addListener('keyboardWillHide', (e) => this._keyboardWillHide(e));
    }
  },

  componentWillUnmount : function()
  {
    if( this._keyboardWillShowSubscription ) this._keyboardWillShowSubscription.remove();
    if( this._keyboardWillHideSubscription ) this._keyboardWillHideSubscription.remove();

    // DBEvents.removeListener("all", this.dbDidUpdate, this.state.context);
  },

  _keyboardWillShow : function(e)
  {
    this.setKeyboardOffset(e.endCoordinates.height);
  },

  _keyboardWillHide : function(e)
  {
    this.setKeyboardOffset(0);
  },

  _keyboardOffset : 0,
  _changingKeyboardOffset : null,
  setKeyboardOffset : function(keyboardOffset)
  {
    if( this._changingKeyboardOffset != null ) clearTimeout(this._changingKeyboardOffset);

    var thisThing = this;
    this._changingKeyboardOffset = setTimeout(function()
    {
      thisThing._keyboardOffset = keyboardOffset;
      Animated.spring(thisThing.state.keyboardOffset,
      {
        toValue: keyboardOffset,
        friction: 6
      }).start();
    },100);
  },

  getDefaultProps: function()
  {
    return {
      interstitialDidFinish:function(){},
    }
  },

  skipTutorialAndLogAnalytic: function()
  {
    if ( this.props.interstitialDidFinish != null )
    {
      var indexAndPageString = this.refs.tutorial.getInfoForSkip();
      AnalyticsManager.logCustomEvent('Skip Tutorial', {'Index and Page': indexAndPageString})
      this.props.interstitialDidFinish();
    }
  },

  networkErrorOccurred: function()
  {
    if ( this.props.interstitialDidFinish != null )
    {
      this.props.interstitialDidFinish((appActions)=>
      {
        appActions.showNetworkErrorAlert(appActions.hideAlert, function(){});
      })
    }
  },

  checkUserChanged: function()
  {
    var thisThing = this;
    var paymentTypePrereq = this.props.appManager.getPrerequisiteFeatureForName("PaymentTypes");
    var addCreditPrereq = this.props.appManager.getPrerequisiteFeatureForName("AddCredit");
    var phoneNumberVerifyFeatureData = this.props.appManager.getFeatureForName('PhoneNumberVerify');
    var state = {};
    if( typeof phoneNumberVerifyFeatureData !== 'undefined'
      && ( (addCreditPrereq != null && addCreditPrereq.data.name == "PhoneNumberVerify") || (paymentTypePrereq != null && paymentTypePrereq.data.name == "PhoneNumberVerify") ))
    {
      this.state.phoneNumberVerifyFeatureData = phoneNumberVerifyFeatureData;
      this.state.phoneNumberVerifyComponent = this.props.featureBuilder.featureForData(phoneNumberVerifyFeatureData, {width:0, height:0}, this.props.appManager,
        {
          useInterstitialFlow: true,
          setPhoneDidFinish: (completion)=>
          {
            thisThing.forceUpdate();
            thisThing.refs.tutorial.goNext(completion);
          },
          showNetworkErrorAlert: ()=>
          {
            thisThing.networkErrorOccurred();
          }
        });
      this.setState(state);
    }

    var additionalPages = [];
    // if( typeof thisThing.state.createUserComponent !== 'undefined' ) additionalPages.push(thisThing.state.createUserComponent);
    // if( typeof thisThing.state.phoneNumberVerifyComponent !== 'undefined' ) additionalPages.push(thisThing.state.phoneNumberVerifyComponent);
    // if( typeof thisThing.state.paymentTypesComponent !== 'undefined' ) additionalPages.push(thisThing.state.paymentTypesComponent);
    // if( typeof thisThing.state.addCreditComponent !== 'undefined' ) additionalPages.push(thisThing.state.addCreditComponent);

    var additionalPageDatas = [];
    // if( typeof thisThing.state.createUserFeatureData !== 'undefined' ) additionalPageDatas.push(thisThing.state.createUserFeatureData);
    // if( typeof thisThing.state.phoneNumberVerifyFeatureData !== 'undefined' ) additionalPageDatas.push(thisThing.state.phoneNumberVerifyFeatureData);
    // if( typeof thisThing.state.paymentTypesFeatureData !== 'undefined' ) additionalPageDatas.push(thisThing.state.paymentTypesFeatureData);
    // if( typeof thisThing.state.addCreditFeatureData !== 'undefined' ) additionalPageDatas.push(thisThing.state.addCreditFeatureData);

    this.refs.tutorial.setAdditionalPages(additionalPages, additionalPageDatas)
  },

  render: function()
  {
    var thisThing = this;

    var splashImageURI = PlatformConstants.resourcesDirectory + '/App/Splash.png';
    if( !this.state.resourcesSynced )
    {
      splashImageURI = PlatformConstants.packagedResourcesDirectory + '/App/Splash.png';
    }

    var appManager = this.props.appManager;
    var headerColor = appManager.getColorForKey("HeaderColor")

    var createUserComponent = this.state.createUserComponent;
    var paymentTypesComponent = this.state.paymentTypesComponent;
    var addCreditComponent = this.state.addCreditComponent;
    var locManager = appManager.getLocalizationManager();

    var additionalPages = [];
    // if( typeof thisThing.state.createUserComponent !== 'undefined' ) additionalPages.push(thisThing.state.createUserComponent);
    // if( typeof thisThing.state.phoneNumberVerifyComponent !== 'undefined' ) additionalPages.push(thisThing.state.phoneNumberVerifyComponent);
    // if( typeof thisThing.state.paymentTypesComponent !== 'undefined' ) additionalPages.push(thisThing.state.paymentTypesComponent);
    // if( typeof thisThing.state.addCreditComponent !== 'undefined' ) additionalPages.push(thisThing.state.addCreditComponent);

    var additionalPageDatas = [];
    // if( typeof thisThing.state.createUserFeatureData !== 'undefined' ) additionalPageDatas.push(thisThing.state.createUserFeatureData);
    // if( typeof thisThing.state.phoneNumberVerifyFeatureData !== 'undefined' ) additionalPageDatas.push(thisThing.state.phoneNumberVerifyFeatureData);
    // if( typeof thisThing.state.paymentTypesFeatureData !== 'undefined' ) additionalPageDatas.push(thisThing.state.paymentTypesFeatureData);
    // if( typeof thisThing.state.addCreditFeatureData !== 'undefined' ) additionalPageDatas.push(thisThing.state.addCreditFeatureData);

    return (
      <View style={[styles.container,{flex: 1, justifyContent: 'center', flexDirection: 'column'}]} onLayout={(info)=>
        {
          var newLayout = info.nativeEvent.layout;
          newLayout.height = newLayout.height - (Globals.ACTION_BAR_HEIGHT);
          if( thisThing.state.layout == null || thisThing.state.layout.height != newLayout.height ) thisThing.setState({layout:newLayout})
        }}>
        <BlurView style={{flex:1, alignSelf:'stretch'}} imageName={splashImageURI} innerView={
          <View style={{position:'absolute', top:0, left:0, right:0, backgroundColor:'transparent', height:Globals.ACTION_BAR_HEIGHT }} />
        } />
        <View style={{position:'absolute', left:0, right:0, top:0, flexDirection:'row', height:Globals.ACTION_BAR_HEIGHT, paddingHorizontal:10, alignItems:'center', paddingTop:Globals.STATUS_BAR_HEIGHT}}>
          <Animated.View style={{position:'absolute', opacity:this.state.headerOpacity, left:0, right:0, top:0, bottom:0, paddingTop:Globals.STATUS_BAR_HEIGHT, backgroundColor:headerColor, flexDirection:'row', justifyContent:'center', alignItems:'center'}}>
            <View style={{flex:1, alignSelf:'stretch', marginHorizontal:50, alignItems:'center', justifyContent:'center', flexDirection:'row'}}>
              <ReUpText appManager={appManager} isSuperTitle={true} shrinksAtLength={20} style={[{color: appManager.getColorForKey("HeaderTitleColor")}]}>
                {this.state.title}
              </ReUpText>
            </View>
          </Animated.View>
          <View style={{flex:1}} />
          <ReUpButton isSkip={true} text={locManager.localizedStringForKeyAndParams('SKIP_BUTTON')} appManager={this.props.appManager} onPress={()=>this.skipTutorialAndLogAnalytic()} style={{width:80}} />
        </View>
        {
          this.state.layout != null ?
            <View style={{position:'absolute', top:Globals.ACTION_BAR_HEIGHT, left:0, right:0, bottom:0}}>
              <Tutorial ref={"tutorial"} initialLayout={this.state.layout} appManager={this.props.appManager}
                shouldShowCloseButton={false}
                useInterstitialFlow={true}
                tutorialDidFinish={(completion)=>{this.props.interstitialDidFinish(completion)}}
                extras={{
                  additionalPages: additionalPages,
                  additionalPageDatas: additionalPageDatas,
                  didShowAdditional:()=>
                  {
                    Animated.timing(
                    thisThing.state.headerOpacity,
                    {toValue: 1,
                    duration:300},
                    ).start(function()
                    {

                    });
                  },
                  didChangeTitle:(newTitle)=>
                  {
                    thisThing.setState({title:newTitle});
                  },
                }}
               />
               <Animated.View style={{height:this.state.keyboardOffset, width:100, opacity:0}} />
            </View>
          : <View style={{flex:1, alignSelf:'stretch'}} />
        }
      </View>
    )
  }
});

var styles = StyleSheet.create({
  container: {
    position:'absolute',
    top:0,
    left:0,
    right:0,
    bottom:0,
    flexDirection:'column'
  }
});

InterstitialContainer.getShouldShow = function(appManager, gotShouldShow)
{
  Tutorial.getLastViewed(appManager, function(date)
  {
    gotShouldShow(date == null);
  })
}

module.exports = InterstitialContainer;



// WEBPACK FOOTER //
// ./src/InterstitialContainer.js